import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { showNotification } from '@mantine/notifications';
import { QUERY_KEYS } from '@/constants/queryKeys';
import { myParishService } from '@/services/my-parish.service';
import type { MyParishUpdateRequest } from '@/types/myParish';

export const useMyParish = (churchId: string | undefined) => {
  return useQuery({
    queryKey: [QUERY_KEYS.MY_PARISH, churchId],
    queryFn: () => myParishService.getMyParish(churchId ?? ''),
    enabled: !!churchId,
  });
};

export const useUpdateMyParishMutation = (churchId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: MyParishUpdateRequest) => myParishService.updateMyParish(churchId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.MY_PARISH, churchId] });
      showNotification({ title: 'Success', message: 'My Parish updated successfully', color: 'green' });
    },
  });
};
